import trRoutes from './tr';
import enRoutes from './en';

const routeSet = (process.env.REACT_APP_ROUTE_SET || '').toLowerCase();

let selected = trRoutes;
if (routeSet === 'en' || process.env.REACT_APP_LOCALE === 'en') {
  selected = enRoutes;
}

export const routes = selected;
export default routes;
